/**
 * Generate a 30-year monthly GBM stock price simulation
 * with optional downtrend and recovery phase.
 */
function generateStockCSV({
  companyName = "sample_company",
  behavior = "",
  fundType = "",
  investType =  "",
  startPrice = 100,
  mu = 0.15,                   // Annual return
  sigma = 0.30,                // Annual volatility
  years = 30,
  months = 0,
  volumeMean = 1000000,
  monthAdjust = 0,
  volumeVariance = 200000,
  initialDate = new Date(2025, 6, 1),  // July 2025
  significantDowntrend = null ,        // Optional crash config
  createHeader = true
}) {
  const dt = 1 / 12;                 // Monthly time step
 
  let n = 0;
  if (months === 0) {
     n = years * 12;
  } else {
     n = months;
  }

  let dates = [];
  for (let i = 0; i < n; i++) {
    let d = new Date(initialDate);
    d.setMonth(d.getMonth() + i);
    dates.push(d);
  }

  const typeConfigs = {
    equity: { mu: 0.07, sigma: 0.12 },
    bond: { mu: 0.03, sigma: 0.05 },
    balanced: { mu: 0.05, sigma: 0.08 }
  };

  if (fundType in typeConfigs) {
    mu = typeConfigs[fundType].mu;
    sigma = typeConfigs[fundType].sigma;
  }


  let prices = [startPrice];
  let inRecovery = false;

  // Determine whether recovery will happen (if applicable)
  let willRecover = false;
  if (significantDowntrend && significantDowntrend.recovery) {
    const chance = significantDowntrend.recovery.chance || 0;
    willRecover = Math.random() < chance;
  }

  for (let i = 1; i < n; i++) {
    const monthsElapsed = i;
    const currentYear = initialDate.getFullYear() + Math.floor(monthsElapsed / 12);

    let localMu = mu;
    let localSigma = sigma;

    // Apply downtrend if within range
    if (significantDowntrend) {
      const {
        startYear,
        durationYears,
        driftMultiplier = -0.8,
        volatilityMultiplier = 1.5,
        recovery = null
      } = significantDowntrend;

      const endYear = startYear + durationYears;

      if (currentYear >= startYear && currentYear < endYear) {
        localMu = mu * driftMultiplier;
        localSigma = sigma * volatilityMultiplier;
      } else if (currentYear >= endYear && recovery && willRecover) {
        // Recovery phase starts
        localMu = mu * (recovery.driftMultiplier ?? 0.5);
        localSigma = sigma * (recovery.volatilityMultiplier ?? 1.2);
        inRecovery = true;
      }
    }

    // GBM simulation
    let u1 = Math.random();
    let u2 = Math.random();
    let z = Math.sqrt(-2 * Math.log(u1)) * Math.cos(2 * Math.PI * u2);

    let prevPrice = prices[i - 1];
    let drift = (localMu - (localSigma ** 2) / 2) * dt;
    let diffusion = localSigma * Math.sqrt(dt) * z;

    let newPrice = prevPrice * Math.exp(drift + diffusion);
    const fundExpenseRatios = {
        equity: 0.01,
        bond: 0.005,
        balanced: 0.01,
      };

      if (fundType in fundExpenseRatios) {
          let expenseRatio = fundExpenseRatios[fundType];
          if (investType === "index" ) {
              expenseRatio *= 0.2;  // Reduce fee by 80% for index fund
          }
          const monthlyFeeFactor = Math.exp(-expenseRatio * dt);
          newPrice *= monthlyFeeFactor;
  }
    
    prices.push(newPrice);
  }

   let csvRows = [];
   if (createHeader === true){
      const headingLine = {company: "investShortName", behavior: "behavior", monthNbr: "monthNbr", 
            close: "closingPrice", open: "openPrice", high: "highPrice", low: "lowPrice", 
            volume: "volume"}; 
      csvRows.push(headingLine);
   }
  
  // Build report file
  for (let i = 0; i < n; i++) {
    const monthNbr = (i + 1 + monthAdjust).toString();
    let closePrice = (prices[i]).toFixed(2);
    let openPrice = 0;
    if (i===0){
      openPrice = startPrice;
    }else{
      openPrice = (prices[i-1]).toFixed(2);
    }
    let highPrice = (Math.max(openPrice, closePrice) * (1 + Math.random() * 0.02)).toFixed(2);
    let lowPrice = (Math.min(openPrice, closePrice) * (1 - Math.random() * 0.02)).toFixed(2);
    let volume = "0.00";
    if (fundType === "") {
        volume = (Math.round(volumeMean + (Math.random() - 0.5) * volumeVariance)).toFixed(2);
    }
    openPrice = openPrice.toString();
    closePrice = closePrice.toString();
    highPrice = highPrice.toString();
    lowPrice = lowPrice.toString();
    volume = volume.toString();
    const rptLine = {company: companyName, behavior: behavior, monthNbr: monthNbr, 
      close: closePrice, open: openPrice, high: highPrice, low: lowPrice, volume: volume};   
    csvRows.push(rptLine);
  }
  return csvRows;
  /*
  // Build CSV

  
  function formatDate(date) {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  }
  let csvRows = ["Date,Open,High,Low,Close,Volume"];
  
  for (let i = 0; i < n; i++) {
    const dateStr = formatDate(dates[i]);
    const close = prices[i];
    const open = i === 0 ? startPrice : prices[i - 1];
    const high = Math.max(open, close) * (1 + Math.random() * 0.02);
    const low = Math.min(open, close) * (1 - Math.random() * 0.02);
    const volume = Math.round(volumeMean + (Math.random() - 0.5) * volumeVariance);

    csvRows.push(
      `${dateStr},${open.toFixed(2)},${high.toFixed(2)},${low.toFixed(
        2
      )},${close.toFixed(2)},${volume}`
    );
  }

  const safeName = companyName.toLowerCase().replace(/\s+/g, "_");
  const fileName = `${safeName}_30yr.csv`;
  const filePath = path.join(__dirname, "../public", fileName);

  fs.writeFileSync(filePath, csvRows.join("\n"));
  */
}

export default generateStockCSV;
